/**
 * Line Style Helpers
 *
 * Utility functions for converting line styles to MapLibre dash arrays.
 *
 * @module components/map/GeometryRenderer/LineRenderer/utils/lineStyleHelpers
 */

import { LineStyle } from '../../../../../types/geometry';

/**
 * Convert LineStyle enum to MapLibre dash array
 *
 * Dash array format: [dash, gap]
 * - Solid: [1, 0] - no gaps
 * - Dashed: [4, 2] - 4px dash, 2px gap
 * - Dotted: [1, 2] - 1px dot, 2px gap
 *
 * @param lineStyle - The line style enum value
 * @returns Dash array for MapLibre line-dasharray property
 *
 * @example
 * ```typescript
 * const dashArray = getDashArray(LineStyle.Dashed);
 * // Returns: [4, 2]
 * ```
 */
export function getDashArray(lineStyle: LineStyle | undefined): number[] {
  switch (lineStyle) {
    case LineStyle.Solid:
      return [1, 0];
    case LineStyle.Dashed:
      return [4, 2];
    case LineStyle.Dotted:
      return [1, 2];
    default:
      return [1, 0]; // Default to solid
  }
}
